(() => {
  const getWhatsappUrl = () =>
    document.querySelector('[data-superfoot-header]')?.dataset.whatsappUrl?.trim() || '';

  const hydrateWhatsappLinks = (root = document) => {
    const whatsappUrl = getWhatsappUrl();
    if (!whatsappUrl) return;

    root.querySelectorAll('.sf-whatsapp-link').forEach((link) => {
      link.href = whatsappUrl;
      link.hidden = false;
    });

    root.querySelectorAll('.sf-whatsapp-link-fallback').forEach((fallback) => {
      fallback.hidden = true;
    });
  };

  const init = () => {
    const modalContent = document.getElementById('quick-add-modal-content');
    if (!modalContent) return;

    hydrateWhatsappLinks(modalContent);

    const observer = new MutationObserver(() => {
      hydrateWhatsappLinks(modalContent);
    });

    observer.observe(modalContent, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
